<template>
    <div>
        <div class="text-center" v-if="type === 'no_more'">
            <img width="100" height="100" src="~/assets/assets/noresult.jpg">
            <h3 class="my-3">That's all on your search!</h3>
            <p>Give us your ideas and we will bring it to reality <router-link :to="localePath('/')"> {{ $t('customize') }} your {{ $t('jewelry') }}</router-link></p>
        </div>
        <div class="text-center" v-if="type === 'client_network_error'">
            <img width="100" height="100" src="~/assets/assets/noresult.jpg">
            <h3 class="my-3">It seems there was an issue with this search !</h3>
            <p>Please try resetting filters, Thank you</p>
        </div>
        <div v-if="type === 'no_result'" class="text-center">
            <img width="100" height="100" src="~/assets/assets/noresult.jpg">
            <h3>No Result Found</h3>
            <p>There are no results corresponding to your selections. <br>  
            Please expand your chosen criteria, or <router-link :to="localePath('/contact-us')">contact us</router-link> for assistance.</p>
        </div>
        <div v-if="type === 'no_compare'" class="text-center">
            <img width="100" height="100" src="~/assets/assets/noresult.jpg">
            <h3>Nothing to compare</h3>
            <!-- <p>There are no results corresponding to your selections. <br>  
            Please expand your chosen criteria, or contact us for assistance.</p> -->
        </div>
    </div>
</template>
<script setup>
    const localePath = useLocalePath()
    const { type } = defineProps(['type'])

</script>


<style scoped>
h3 {
    font-size: 20px;
}

p {
    font-size: 16px;
    line-height: 1.5;
    font-weight: 500;
    color: #6a6161;
}
a {
    font-size: 16px;
    color: var(--green);
    text-decoration: underline;
    font-weight: 500;
}
</style>
